import { Component, SimpleChanges } from '@angular/core';
import { BaseVraagControlDirective } from '../base/base-vraag-control';
import { Vraag, Antwoord } from '@models/claims';
import { VraagboomEmptyResultaat } from '@models/vragenboom';
import { DataService } from '@components/public_api';

@Component({
  selector: 'app-summary',
  template: ''
})
export class SummaryComponent extends BaseVraagControlDirective<VraagboomEmptyResultaat> {
  constructor(_dataService: DataService) {
    super(_dataService);
   }

  initialize(changes: SimpleChanges): void {
    setTimeout( () => {
      this.setAntwoord(this.vraag.antwoorden, new VraagboomEmptyResultaat());
    });
  }
  validate(vraag: Vraag, antwoorden: Antwoord[], resultaat: VraagboomEmptyResultaat): boolean {
    return this.vraag != null;
  }
}
